import React from 'react';
import PropTypes from 'prop-types';
import { displaySuccess } from 'Helpers/FacetNotificationManager';
import View from './View';
import { useApexAdminPortalDispatchContext } from '../../ApexAdminPortalContext';
import {
  setAccountSummaryResource,
  setInvestigationResource,
  setAchRelationshipResource,
  refreshAccountSummaryResource,
} from '../../ApexAdminPortalActions';

const Header = ({ resource }) => {
  const apexDispatch = useApexAdminPortalDispatchContext();

  const refresh = async () => {
    await refreshAccountSummaryResource(resource, apexDispatch, () => {
      displaySuccess('Refreshed Account Request');
    });
  };

  return (
    <View
      resource={resource}
      onClose={() => {
        setAccountSummaryResource(null, apexDispatch);
        setInvestigationResource(null, apexDispatch);
        setAchRelationshipResource(null, apexDispatch);
      }}
      onClickRefresh={refresh}
    />
  );
};

Header.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default Header;
